import { CdkDragDrop } from '@angular/cdk/drag-drop';

export abstract class RepeatableEditor {
  abstract onAddClicked(index: number): void;
  abstract onDeleteClicked(index: number): void;
  abstract dropValue(event: CdkDragDrop<string[]>): void;
}
